unit UCameraForm;

interface

uses
  System.SysUtils, System.Classes, JS, Web, WEBLib.Graphics, WEBLib.Controls,
  WEBLib.Forms, WEBLib.Dialogs, WEBLib.Buttons, WEBLib.StdCtrls, Vcl.Controls,
  WEBLib.Devices, Vcl.StdCtrls, UEssentialHelper, WEBLib.ExtCtrls,
  Vcl.Imaging.pngimage, UMainConfig;

type
  TCameraMode = (cmPaused, cmStarted);

  TCameraForm = class(TForm)
    pnlTop: TPanel;
    pnlBottom: TPanel;
    btnRecord: TBitBtn;
    btnStore: TBitBtn;
    pnlMain: TPanel;
    Webcam: TCamera;
    pnlHeader: TPanel;
    imgLogo: TImageControl;
    lblHeader: TLabel;
    btnBack: TImageControl;
    pnlFooter: TPanel;
    lblCameraTyp: TLabel;
    btnRear: TRadioButton;
    btnFront: TRadioButton;
    btnStart: TBitBtn;
    procedure WebFormCreate(Sender: TObject);
    procedure btnBackClick(Sender: TObject);
    procedure btnRecordClick(Sender: TObject);
    procedure btnStoreClick(Sender: TObject);
    procedure WebFormClose(Sender: TObject; var Action: TCloseAction);
    procedure WebFormResize(Sender: TObject);
    procedure btnRearClick(Sender: TObject);
    procedure btnFrontClick(Sender: TObject);
    procedure btnStartClick(Sender: TObject);
    procedure WebFormOrientationChange(Sender: TObject;
      AOrientation: TScreenOrientation);
  private
    FOnSnapshot: TSnapshotEvent;
    FMainConfig: TMainConfig;
    FCameraMode: TCameraMode;
    FFakNr: string;
    FFilename: string;
    procedure DoSnapshot(Filename: string);
    procedure SetOnSnapshot(const Value: TSnapshotEvent);
    procedure SetMainConfig(const Value: TMainConfig);
    procedure SetCameraMode(const Value: TCameraMode);
    procedure SetFakNr(const Value: string);
    procedure SetFilename(const Value: string);
  public
    property OnSnapshot: TSnapshotEvent read FOnSnapshot write SetOnSnapshot;
    property MainConfig: TMainConfig read FMainConfig write SetMainConfig;
    property CameraMode: TCameraMode read FCameraMode write SetCameraMode;
    property FakNr: string read FFakNr write SetFakNr;
    property Filename: string read FFilename write SetFilename;
  protected procedure LoadDFMValues; override; end;

var
  CameraForm: TCameraForm;

implementation

uses
  System.NetEncoding, WEBLib.LocalFiles;

{$R *.dfm}

procedure TCameraForm.btnBackClick(Sender: TObject);
begin
  Self.MainConfig.TimerReset;
  Self.Close;
end;

procedure TCameraForm.btnFrontClick(Sender: TObject);
begin
  Self.MainConfig.TimerReset;
  Webcam.Stop;
  Webcam.CameraType := ctFront;
  Webcam.Start;
end;

procedure TCameraForm.btnRearClick(Sender: TObject);
begin
  Self.MainConfig.TimerReset;
  Webcam.Stop;
  Webcam.CameraType := ctRear;
  Webcam.Start;
end;

procedure TCameraForm.btnRecordClick(Sender: TObject);
begin
  Self.MainConfig.TimerReset;
  Self.CameraMode := cmPaused;
  Webcam.Pause;
  Self.WebFormResize(Sender);
end;

procedure TCameraForm.btnStartClick(Sender: TObject);
begin
  self.MainConfig.TimerReset;
  Self.CameraMode := cmStarted;
  Webcam.Resume;
  Self.WebFormResize(Sender);
end;

procedure TCameraForm.btnStoreClick(Sender: TObject);
var
  tFile: TTextFile;
  procedure HandleFileSave(Sender: TObject);
  begin
    Self.DoSnapshot(Self.Filename);
    Self.Close;
  end;

begin
  Self.MainConfig.TimerReset;
  Self.Filename := FormatDateTime('yyyymmdd_hhnnss', now) + '.png';
  tFile := TTextFile.Create(nil);
  tFile.OnFileSave := HandleFileSave;
  tFile.Text := Webcam.SnapShotAsBase64;
  tFile.SaveAsFile(Self.FakNr + '\Pictures', Self.Filename);
end;

procedure TCameraForm.DoSnapshot(Filename: string);
begin
  if Assigned(Self.OnSnapshot) then
    Self.OnSnapshot(Self, Filename, akPicture);
  Webcam.Stop;
end;

procedure TCameraForm.SetCameraMode(const Value: TCameraMode);
begin
  FCameraMode := Value;
end;

procedure TCameraForm.SetFakNr(const Value: string);
begin
  FFakNr := Value;
end;

procedure TCameraForm.SetFilename(const Value: string);
begin
  FFilename := Value;
end;

procedure TCameraForm.SetMainConfig(const Value: TMainConfig);
begin
  FMainConfig := Value;
  Self.MainConfig.CurrentForm := Self.Name;
  ColorComponents(Self, Self.MainConfig.ColorConfig);
  pnlFooter.Caption := Self.MainConfig.Copyright;
  Self.WebFormResize(Self);
end;

procedure TCameraForm.SetOnSnapshot(const Value: TSnapshotEvent);
begin
  FOnSnapshot := Value;
end;

procedure TCameraForm.WebFormClose(Sender: TObject; var Action: TCloseAction);
begin
  Webcam.Stop;
end;

procedure TCameraForm.WebFormCreate(Sender: TObject);
begin
  Self.FakNr := '';
  Self.Filename := '';
  Webcam.CameraType := ctRear;
  Webcam.Start;
  Self.CameraMode := cmStarted;
end;

procedure TCameraForm.WebFormOrientationChange(Sender: TObject;
  AOrientation: TScreenOrientation);
begin
  Self.WebFormResize(Sender);
end;

procedure TCameraForm.WebFormResize(Sender: TObject);
begin
  if (Self.Height < 480) or (Self.Width < 640) then
  begin
    btnBack.Width := 24;
    btnBack.Height := 24;
    btnBack.Top := 4;
    btnBack.Left := 4;
    lblHeader.Font.Size := 10;
    lblHeader.Top := 7;
    imgLogo.Width := 74;
    imgLogo.Height := 24;
    imgLogo.Top := 4;
    pnlHeader.Height := 32;
    pnlFooter.Visible := false;
    lblHeader.Caption := 'Kamera';
  end
  else
  begin
    btnBack.Width := 48;
    btnBack.Height := 48;
    btnBack.Top := 8;
    btnBack.Left := 8;
    lblHeader.Font.Size := 16;
    lblHeader.Top := 16;
    imgLogo.Width := 148;
    imgLogo.Height := 48;
    imgLogo.Top := 8;
    pnlHeader.Height := 64;
    pnlFooter.Visible := true;
    lblHeader.Caption := 'Winzeit - WebPortal - Kamera';
  end;
  pnlHeader.Width := Self.ClientWidth;
  pnlFooter.Width := pnlHeader.Width;
  lblHeader.Left := btnBack.Left + btnBack.Width + 8;
  lblHeader.Width := pnlHeader.ClientWidth - imgLogo.Width - 32;
  imgLogo.Left := pnlHeader.ClientWidth - imgLogo.Width - 16;
  btnStart.Left := btnRecord.Left;
  btnRecord.Visible := Self.CameraMode = cmStarted;
  btnStart.Visible := Self.CameraMode = cmPaused;
  btnStore.Left := pnlBottom.ClientWidth - btnStore.Width - 6;
  btnStore.Enabled := Self.CameraMode = cmPaused;
  btnRear.Enabled := Self.CameraMode = cmStarted;
  btnFront.Enabled := Self.CameraMode = cmStarted;
end;

procedure TCameraForm.LoadDFMValues;
begin
  inherited LoadDFMValues;

  pnlTop := TPanel.Create(Self);
  lblCameraTyp := TLabel.Create(Self);
  btnRear := TRadioButton.Create(Self);
  btnFront := TRadioButton.Create(Self);
  pnlBottom := TPanel.Create(Self);
  btnRecord := TBitBtn.Create(Self);
  btnStore := TBitBtn.Create(Self);
  btnStart := TBitBtn.Create(Self);
  pnlMain := TPanel.Create(Self);
  Webcam := TCamera.Create(Self);
  pnlHeader := TPanel.Create(Self);
  imgLogo := TImageControl.Create(Self);
  lblHeader := TLabel.Create(Self);
  btnBack := TImageControl.Create(Self);
  pnlFooter := TPanel.Create(Self);

  pnlTop.BeforeLoadDFMValues;
  lblCameraTyp.BeforeLoadDFMValues;
  btnRear.BeforeLoadDFMValues;
  btnFront.BeforeLoadDFMValues;
  pnlBottom.BeforeLoadDFMValues;
  btnRecord.BeforeLoadDFMValues;
  btnStore.BeforeLoadDFMValues;
  btnStart.BeforeLoadDFMValues;
  pnlMain.BeforeLoadDFMValues;
  Webcam.BeforeLoadDFMValues;
  pnlHeader.BeforeLoadDFMValues;
  imgLogo.BeforeLoadDFMValues;
  lblHeader.BeforeLoadDFMValues;
  btnBack.BeforeLoadDFMValues;
  pnlFooter.BeforeLoadDFMValues;
  try
    Name := 'CameraForm';
    Width := 645;
    Height := 640;
    SetEvent(Self, 'OnClose', 'WebFormClose');
    SetEvent(Self, 'OnCreate', 'WebFormCreate');
    SetEvent(Self, 'OnOrientationChange', 'WebFormOrientationChange');
    SetEvent(Self, 'OnResize', 'WebFormResize');
    pnlTop.SetParentComponent(Self);
    pnlTop.Name := 'pnlTop';
    pnlTop.Left := 0;
    pnlTop.Top := 64;
    pnlTop.Width := 645;
    pnlTop.Height := 31;
    pnlTop.Align := alTop;
    pnlTop.Caption := 'pnlTop';
    pnlTop.ChildOrder := 6;
    pnlTop.ShowCaption := False;
    lblCameraTyp.SetParentComponent(pnlTop);
    lblCameraTyp.Name := 'lblCameraTyp';
    lblCameraTyp.Left := 8;
    lblCameraTyp.Top := 8;
    lblCameraTyp.Width := 67;
    lblCameraTyp.Height := 15;
    lblCameraTyp.Caption := 'Kamera-Typ:';
    lblCameraTyp.HeightPercent := 100.000000000000000000;
    lblCameraTyp.WidthPercent := 100.000000000000000000;
    btnRear.SetParentComponent(pnlTop);
    btnRear.Name := 'btnRear';
    btnRear.Left := 87;
    btnRear.Top := 5;
    btnRear.Width := 75;
    btnRear.Height := 22;
    btnRear.Caption := 'R'#252'ck';
    btnRear.Checked := True;
    btnRear.ChildOrder := 1;
    btnRear.Color := clNone;
    btnRear.GroupName := '1';
    btnRear.HeightPercent := 100.000000000000000000;
    btnRear.WidthPercent := 100.000000000000000000;
    SetEvent(btnRear, Self, 'OnClick', 'btnRearClick');
    btnFront.SetParentComponent(pnlTop);
    btnFront.Name := 'btnFront';
    btnFront.Left := 168;
    btnFront.Top := 5;
    btnFront.Width := 75;
    btnFront.Height := 22;
    btnFront.Caption := 'Front';
    btnFront.Checked := False;
    btnFront.ChildOrder := 2;
    btnFront.Color := clNone;
    btnFront.GroupName := '1';
    btnFront.HeightPercent := 100.000000000000000000;
    btnFront.WidthPercent := 100.000000000000000000;
    SetEvent(btnFront, Self, 'OnClick', 'btnFrontClick');
    pnlBottom.SetParentComponent(Self);
    pnlBottom.Name := 'pnlBottom';
    pnlBottom.Left := 0;
    pnlBottom.Top := 568;
    pnlBottom.Width := 645;
    pnlBottom.Height := 48;
    pnlBottom.Align := alBottom;
    pnlBottom.Caption := 'pnlBottom';
    pnlBottom.ChildOrder := 6;
    pnlBottom.ShowCaption := False;
    btnRecord.SetParentComponent(pnlBottom);
    btnRecord.Name := 'btnRecord';
    btnRecord.Tag := 1;
    btnRecord.Left := 4;
    btnRecord.Top := 4;
    btnRecord.Width := 40;
    btnRecord.Height := 40;
    btnRecord.Color := clNone;
    btnRecord.Glyph.LoadFromFile('UCameraForm.pnlBottom.btnRecord.Glyph.png');
    btnRecord.GlyphSize := 32;
    btnRecord.HeightPercent := 100.000000000000000000;
    btnRecord.WidthPercent := 100.000000000000000000;
    SetEvent(btnRecord, Self, 'OnClick', 'btnRecordClick');
    btnStore.SetParentComponent(pnlBottom);
    btnStore.Name := 'btnStore';
    btnStore.Left := 541;
    btnStore.Top := 4;
    btnStore.Width := 40;
    btnStore.Height := 40;
    btnStore.Hint := 'Foto '#252'bernehmen';
    btnStore.Color := clNone;
    btnStore.Enabled := False;
    btnStore.Glyph.LoadFromFile('UCameraForm.pnlBottom.btnStore.Glyph.png');
    btnStore.GlyphSize := 32;
    btnStore.HeightPercent := 100.000000000000000000;
    btnStore.ShowHint := True;
    btnStore.WidthPercent := 100.000000000000000000;
    SetEvent(btnStore, Self, 'OnClick', 'btnStoreClick');
    btnStart.SetParentComponent(pnlBottom);
    btnStart.Name := 'btnStart';
    btnStart.Left := 64;
    btnStart.Top := 4;
    btnStart.Width := 40;
    btnStart.Height := 40;
    btnStart.Color := clNone;
    btnStart.Glyph.LoadFromFile('UCameraForm.pnlBottom.btnStart.Glyph.png');
    btnStart.GlyphSize := 32;
    btnStart.HeightPercent := 100.000000000000000000;
    btnStart.WidthPercent := 100.000000000000000000;
    SetEvent(btnStart, Self, 'OnClick', 'btnStartClick');
    pnlMain.SetParentComponent(Self);
    pnlMain.Name := 'pnlMain';
    pnlMain.Left := 0;
    pnlMain.Top := 95;
    pnlMain.Width := 645;
    pnlMain.Height := 473;
    pnlMain.Align := alClient;
    pnlMain.Caption := 'pnlMain';
    pnlMain.ChildOrder := 3;
    pnlMain.ShowCaption := False;
    Webcam.SetParentComponent(pnlMain);
    Webcam.Name := 'Webcam';
    Webcam.Left := 0;
    Webcam.Top := 0;
    Webcam.Width := 645;
    Webcam.Height := 473;
    Webcam.Align := alClient;
    Webcam.BaseFormat := cbfPNG;
    pnlHeader.SetParentComponent(Self);
    pnlHeader.Name := 'pnlHeader';
    pnlHeader.Left := 0;
    pnlHeader.Top := 0;
    pnlHeader.Width := 645;
    pnlHeader.Height := 64;
    pnlHeader.Align := alTop;
    pnlHeader.Caption := 'pnlHeader';
    pnlHeader.ChildOrder := 4;
    pnlHeader.Color := clSkyBlue;
    pnlHeader.ShowCaption := False;
    imgLogo.SetParentComponent(pnlHeader);
    imgLogo.Name := 'imgLogo';
    imgLogo.Left := 480;
    imgLogo.Top := 8;
    imgLogo.Width := 148;
    imgLogo.Height := 48;
    imgLogo.HeightPercent := 100.000000000000000000;
    imgLogo.WidthPercent := 100.000000000000000000;
    imgLogo.Picture.LoadFromFile('UCameraForm.pnlHeader.imgLogo.Picture.png');
    lblHeader.SetParentComponent(pnlHeader);
    lblHeader.Name := 'lblHeader';
    lblHeader.Left := 64;
    lblHeader.Top := 16;
    lblHeader.Width := 410;
    lblHeader.Height := 30;
    lblHeader.Alignment := taCenter;
    lblHeader.AutoSize := False;
    lblHeader.Caption := 'Winzeit - WebPortal - Kamera';
    lblHeader.Font.Charset := DEFAULT_CHARSET;
    lblHeader.Font.Color := clWindowText;
    lblHeader.Font.Height := -21;
    lblHeader.Font.Name := 'Segoe UI';
    lblHeader.Font.Style := [fsBold];
    lblHeader.HeightPercent := 100.000000000000000000;
    lblHeader.ParentFont := False;
    lblHeader.WidthPercent := 100.000000000000000000;
    btnBack.SetParentComponent(pnlHeader);
    btnBack.Name := 'btnBack';
    btnBack.Left := 16;
    btnBack.Top := 16;
    btnBack.Width := 32;
    btnBack.Height := 32;
    btnBack.HeightPercent := 100.000000000000000000;
    btnBack.WidthPercent := 100.000000000000000000;
    btnBack.ChildOrder := 2;
    SetEvent(btnBack, Self, 'OnClick', 'btnBackClick');
    btnBack.Picture.LoadFromFile('UCameraForm.pnlHeader.btnBack.Picture.png');
    pnlFooter.SetParentComponent(Self);
    pnlFooter.Name := 'pnlFooter';
    pnlFooter.Left := 0;
    pnlFooter.Top := 616;
    pnlFooter.Width := 645;
    pnlFooter.Height := 24;
    pnlFooter.Align := alBottom;
    pnlFooter.Alignment := taLeftJustify;
    pnlFooter.Caption := 'pnlFooter';
    pnlFooter.ChildOrder := 1;
    pnlFooter.Color := clSkyBlue;
  finally
    pnlTop.AfterLoadDFMValues;
    lblCameraTyp.AfterLoadDFMValues;
    btnRear.AfterLoadDFMValues;
    btnFront.AfterLoadDFMValues;
    pnlBottom.AfterLoadDFMValues;
    btnRecord.AfterLoadDFMValues;
    btnStore.AfterLoadDFMValues;
    btnStart.AfterLoadDFMValues;
    pnlMain.AfterLoadDFMValues;
    Webcam.AfterLoadDFMValues;
    pnlHeader.AfterLoadDFMValues;
    imgLogo.AfterLoadDFMValues;
    lblHeader.AfterLoadDFMValues;
    btnBack.AfterLoadDFMValues;
    pnlFooter.AfterLoadDFMValues;
  end;
end;

end.
